import React from "react";
import { Flex, type FlexProps, type LinkProps } from "@chakra-ui/react";
import { Link } from "./link/link";

type LinkCardProps = {
  href: LinkProps["href"];
  linkAriaLabel?: string;
  target?: LinkProps["target"];
} & FlexProps;

export function LinkCard({ href, target, linkAriaLabel, children, ...props }: LinkCardProps) {
  return (
    <Flex pos="relative" flexDirection="column" p={12} alignItems="flex-start" role="group" {...props}>
      <Link
        href={href}
        target={target}
        aria-label={linkAriaLabel}
        pos="absolute"
        left={0}
        top={0}
        w="100%"
        h="100%"
        zIndex={5}
      />
      {children}
    </Flex>
  );
}
